import SlideToggler from "./slide-toggler";

export default class ModalHandler {
    constructor() {
        this.slideToggler = new SlideToggler();
        this.initListeners()
    }

    initListeners() {
        cl.addEvent(document,'click', '#connect-modal .switcher', (e) => {
            let _this = e.target;
            let where = _this.dataset.where;
            document.querySelectorAll('.switcher').forEach((el) => {
                el.classList.remove('checked')
            })
            _this.classList.add('checked')
            let hidden = document.querySelector('.js-hidden-where')
            if (hidden) {
                hidden.value = where;
            }
        })

        // открытие списка городов в форме заявки на подключение
        cl.addEvent(document,'click', '#connect-modal .current-city', (e) => {
            let dropdown = document.querySelector('#connect-modal .dropdown-list-wrapper')
            if (dropdown) {
                this.slideToggler.slideToggle(dropdown)
            }
        })

        // установка города
        cl.addEvent(document,'click', '#connect-modal .dropdown-list .item', (e) => {
            let dropdown = document.querySelector('#connect-modal .dropdown-list-wrapper')
            let city = e.target.dataset.city;
            let cityName = e.target.textContent.trim();

            let hiddenCity = document.querySelector('#connect-modal [name="city"]');
            if (hiddenCity) {
                hiddenCity.value = cityName;
            }

            fetch(`/city/set/${city}`, {
                method: 'POST',
                headers: cl.headers(),
            })
                .then(r => r.json())
                .then((response) => {
                    let currentCity = document.querySelector('#connect-modal .current-city');
                    let currentPhone = document.querySelector('#connect-modal .phone-number');
                    currentCity.innerText = cityName;
                    currentPhone.innerText = response.phone;
                })

            this.slideToggler.slideToggle(dropdown);
        })
    }
}
